import { saveProduct } from './pages/ProductsEdit/sagas/saveProduct';

export default [saveProduct()];
